// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/tgc.scss
// module id = 719
// module chunks = 0